// Role gates for admin-bucket firefly sections (§5.3).

/** Users who can review pending member access in Admin → Users. */
export const ADMIN_MEMBER_APPROVAL_ROLES = [
  "admin",
  "owner",
  "org_admin",
  "org_owner",
] as const;

/** Owner-as-coach read-only rollup (RA-3 family); narrower than approvals. */
export const ADMIN_ORG_UNSENT_ROLLUP_ROLES = ["owner", "admin"] as const;

export function canRunAdminMemberRpcs(
  hasRole: (...roles: string[]) => boolean,
  realHasRole: (...roles: string[]) => boolean,
): boolean {
  return (
    realHasRole("platform_admin") ||
    hasRole("owner", "admin", "org_owner", "org_admin")
  );
}
